import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    FieldDynamicStyleConstantType,
    FieldDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../types";

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "column"
    }
});

export const useStyles = ({
    orientation,
    spaces
}: FieldDynamicStyleConstantType): FieldDynamicStyleType => {
    const container = {
        gap: spaces.spacingSm
    } as Mutable<ViewStyle>;

    if(orientation === "horizontal") {
        container.flexDirection = "row";
        container.alignItems = "center";
        container.gap = spaces.spacingMd;
    }

    return {
        container
    };
};
export default stylesheet;
